// change the hover state on the drop-down to pink (##FFEAF7)

import { MultiSelect, MultiSelectProps } from '@mantine/core';
import classes from '@/components/StyledInputFields/Inputs.module.css';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type StyledMultiSelectProps = MultiSelectProps & { capabilityFieldId?: string };

const CustomMultiSelect = ({ capabilityFieldId, ...props }: StyledMultiSelectProps) => {
  const label = useCapabilityHelpLabel(props.label, capabilityFieldId);
  return (
    <MultiSelect
      checkIconPosition="right"
      {...props}
      label={label}
      classNames={{
        input: classes.input,
        option: classes.option,
        pill: classes.pill,
        label: classes.label,
      }}
    />
  );
};

export default CustomMultiSelect;
